<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Master Provider</h5>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createMasterProvider'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="masterProvider"
        :items="getInfo"
        :fields="types"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="{ item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
        </template>
        <template v-slot:cell(updated_at)="{ item }">
          <span v-if="item.updated_at_date_only">
            <p class="mb-0">{{item.updated_at_date_only}} by {{item.updated_by_username}}</p>
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:cell(prefix_numbers)="{ item }">
            <p class="mb-0">{{item.prefix_numbers}}</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row>
            <b-link v-b-tooltip.hover title="View" class="text-dark" @click="modalShow = !modalShow">
              <img src="@/assets/ic-view.png" class="mr-2" alt @click="getDetail(item.id)" />
            </b-link>
            <router-link
              v-b-tooltip.hover
              title="Edit"
              :to="{name: 'editMasterProvider', params: {id: item.id}}"
              class="text-dark"
            >
              <img src="@/assets/ic-edit.svg" class="mr-2" alt />
            </router-link>
            <b-form-checkbox
              switch
              v-model="item.status"
              name="check-button"
              @change="activation(item)"
            ></b-form-checkbox>
            <span v-if="item.status" class="text-primary">&nbsp;Active</span>
            <span v-else>&nbsp;Inactive</span>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">Details</h2>
          </b-col>
          <b-col md="3" class="text-right text-primary font-weight-bold">
            <router-link
              class="text-decoration-none text-primary"
              :to="{
                name: 'editMasterProvider',
                params: { id: detail.id },
              }"
            >
              <i class="fas fa-edit"></i>&nbsp; Edit
            </router-link>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Date Created"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.created_at_date_only}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Last Updated"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p v-if="detail.updated_at_date_only" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.updated_at_date_only}} by {{detail.updated_by_username}}</p>
              <label v-else style="font-size: 12px;font-weight: normal !important">-</label>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="PPOB Gateway Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.gateway}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Brand Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.brand_name}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Description (English)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.description ? detail.description.en : ''}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Description (Bahasa)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.description ? detail.description.id : ''}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Type"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.type}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">Parameter</h4>
          </b-col>
        </b-row>
        <b-row v-for="parameter in detail.parameters" :key="parameter.key">
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Key"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{parameter.key}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Value"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{parameter.value}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              @click="modalShow = !modalShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      detail: {},
      modalShow: false,
      types: [
        {
          key: "created_at",
          label: "Created",
          sortable: false,
          class: "text-left"
        },
        {
          key: "updated_at",
          label: "Last Updated",
          sortable: false,
          class: "text-left w-14"
        },
        {
          key: "gateway",
          label: "PPOB Gateway",
          sortable: false,
          class: "text-left"
        },
        {
          key: "brand_name",
          label: "Brand Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "description.en",
          label: "Description Eng",
          sortable: false,
          class: "text-left w-20"
        },
        {
          key: "prefix_numbers",
          label: "Prefix Numbers",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left w-14" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  methods: {
    getDetail(payload) {
      this.$store
        .dispatch("MasterProviderModule/getMasterProvider", payload)
        .then(response => {
          this.detail = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("MasterProviderModule/getMasterProviderWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    activation(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You will change status Provider!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("status", item.status);
          const payload = {
            id: item.id,
            data: formData,
          };
          this.$store
            .dispatch("MasterProviderModule/updateStatus", payload)
            .then((response) => {
              console.log(response);
              this.loading = false;
              this.$refs.masterProvider.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$refs.masterProvider.refresh();
              this.$swal({
                title: "Cannot deactivate",
                text: error.response.data.message,
                confirmButtonColor: "#6051a2",
                confirmButtonText: "Ok",
              });
            });
        } else {
          item.status = !item.status;
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>